import { gql } from "@apollo/client";

import { CALL_RECORD_WITH_PLAYLIST } from "@/graphql-client/fragments";

export const GET_CALL_RECORDS = gql`
  query GetCallRecords(
    $take: Int
    $skip: Int
    $sortDirection: SortingDirection
    $accountId: Int
    $minDuration: Int
    $playlistId: Int
  ) {
    callRecords(
      data: {
        take: $take
        skip: $skip
        sortDirection: $sortDirection
        accountId: $accountId
        minDuration: $minDuration
        playlistId: $playlistId
      }
    ) {
      count
      thisWeek
      lastWeek
      activitiesPlayed
      month
      data {
        ...CallRecordWithPlaylist
      }
    }
  }
  ${CALL_RECORD_WITH_PLAYLIST}
`;

export const GET_CALL_ENGAGEMENT_DURATION = gql`
  query GetCallEngagementDuration($accountId: Int) {
    callDuration(data: { accountId: $accountId })
  }
`;

export const UPDATE_CALL_RECORD = gql`
  mutation UpdateCallRecord($callSid: String!, $data: JSONObject!) {
    updateCallRecord(callSid: $callSid, data: $data) {
      sid
      hbacalldata
    }
  }
`;

export const UPDATE_SESSION_COUNT = gql`
  mutation UpdateSessionCount($callSid: String!, $data: Float!) {
    updateSessionCount(callSid: $callSid, data: $data) {
      sid
      sessionCount
    }
  }
`;

export const UPDATE_HEALTHIE_FORM = gql`
  mutation UpdateHealthieForm($callSid: String!, $data: JSONObject!) {
    updateHealthieForm(callSid: $callSid, data: $data)
  }
`;

export const GET_SINGLE_CALL_RECORD = gql`
  query GetSingleCallRecord($callSid: String!) {
    callRecord(callSid: $callSid) {
      hbacalldata
      sessionCount
      sid
      durationInSeconds
      outcome
      type
      createdOn
      recordingDownloadUrl
      programRating
      fullProgramRatingResponse
      errorDetails
      hangupDetails
      playlist {
        id
        isActive
        startOn
        endOn
        title
        playlistVoiceMessages {
          voiceMessage {
            title
            templateLink
            feature
            cognitiveDomains
          }
        }
      }
      account {
        firstName
        lastName
        id
        timeZone
        Id_Ehr
      }
    }
  }
`;
